/* Hockey Sockey theme behaviour.
   Every block is isolated: a failure in one must not stop the others, which
   is exactly what went wrong when the reveal code silently killed the
   scroll-progress and sticky-header handlers below it. */
function hsSafe(name, fn) {
  try { fn(); } catch (err) {
    if (window.console && console.warn) console.warn('[theme] ' + name + ' failed', err);
  }
}

// Escape text for an HTML attribute or text node. Shared by every block
// that builds markup from cart or product data.
function hsEsc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

// Product recommendations — Shopify renders the section, we swap it in.
hsSafe('recommendations', function () {
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('[data-recommendations]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-recommendations]');
        if (next && next.innerHTML.trim()) el.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  });
});

// Hero reels — cross-fade the home_reel entries.
hsSafe('hero-reels', function () {
  var reels = document.querySelectorAll('[data-hero] [data-reel]');
  if (reels.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var i = 0;
  // Both classes change in the same frame, so the outgoing reel fades out
  // while the incoming one fades in. The old version waited 260ms between
  // the two, leaving the hero blank and making the swap read as a jump.
  setInterval(function () {
    var current = reels[i];
    i = (i + 1) % reels.length;
    reels[i].classList.add('is-active');
    current.classList.remove('is-active');
  }, 7000);
});

// Sticky buy bar on the PDP.
hsSafe('buy-bar', function () {
  var bar = document.querySelector('[data-buy-bar]');
  var form = document.getElementById('pdp-form');
  if (!bar || !form) return;
  // Show the bar once the main add-to-cart form has scrolled out of view.
  // IntersectionObserver where available, with a scroll fallback so the
  // state is always right even when observers are throttled (background
  // tabs, bfcache restores, in-app browsers).
  function check() {
    var r = form.getBoundingClientRect();
    bar.classList.toggle('is-visible', r.bottom < 0 || r.top > window.innerHeight);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(form);
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  window.addEventListener('pageshow', check);
  check();
});

// League tabs on the team picker.
hsSafe('league-tabs', function () {
  var tabs = document.querySelectorAll('[data-league-tab]');
  if (!tabs.length) return;
  Array.prototype.forEach.call(tabs, function (tab) {
    tab.addEventListener('click', function () {
      var league = tab.dataset.leagueTab;
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-league-panel]'), function (p) {
        p.hidden = p.dataset.leaguePanel !== league;
      });
    });
  });
});

// Scroll progress + sticky header background, mirroring the Hydrogen chrome.
hsSafe('scroll-chrome', function () {
  var bar = document.querySelector('[data-scroll-progress]');
  var header = document.querySelector('.site-header');
  if (!bar && !header) return;
  function update() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (bar) bar.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
    if (header) header.classList.toggle('is-stuck', y > 40);
    document.body.classList.toggle('is-scrolled', y > 40);
  }
  // Deliberately not gated behind requestAnimationFrame: a hidden or
  // backgrounded tab never runs rAF, which would leave a "ticking" latch
  // stuck true and kill the handler for the rest of the session. Two DOM
  // writes are cheap enough to run straight from the scroll event.
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
});

// Scroll reveal — content is visible by default and only hidden once the
// observer exists, so this can never leave the page blank.
hsSafe('reveal', function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll(
    '.section__head, .grid > *, .quality__row, .locker > *, .service-strip__item, .crests > *'
  );
  if (!targets.length) return;
  var io = new IntersectionObserver(function (entries) {
    Array.prototype.forEach.call(entries, function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
  Array.prototype.forEach.call(targets, function (el, i) {
    el.classList.add('reveal', 'armed');
    el.style.setProperty('--i', i % 8);
    io.observe(el);
  });
  setTimeout(function () {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
  }, 2500);
});

// League tabs inside the header's team dropdown.
hsSafe('nav-league-tabs', function () {
  var tabs = document.querySelectorAll('[data-navleague]');
  if (!tabs.length) return;
  Array.prototype.forEach.call(tabs, function (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      var lg = tab.dataset.navleague;
      Array.prototype.forEach.call(tabs, function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-navpanel]'), function (p) {
        p.hidden = p.dataset.navpanel !== lg;
      });
    });
  });
});

// ——— shared overlay helpers ————————————————————————————
// Overlays: opening moves keyboard focus inside (the search box, else the
// close button, else the first control), Tab cycles within, and closing hands
// focus back to whatever opened it. Without this a keyboard or screen-reader
// user opens the cart and is still "on" the page behind it.
var hsFocusable = 'a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
function hsTrap(e) {
  var el = e.currentTarget; if (e.key !== 'Tab') return;
  var f = Array.prototype.filter.call(el.querySelectorAll(hsFocusable), function (n) { return n.offsetParent !== null; });
  if (!f.length) return;
  var first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}
function hsOpen(el) {
  if (!el) return; el.hidden = false; document.body.classList.add('overlay-open');
  el._hsReturn = document.activeElement;
  el.addEventListener('keydown', hsTrap);
  var target = el.querySelector('[data-search-input], [autofocus]') || el.querySelector('button[data-cart-close], button[data-size-guide-close], button.drawer__x, button[aria-label^="Close"]') || el.querySelector(hsFocusable);
  if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, 30);
}
function hsClose(el) {
  if (!el) return; el.hidden = true; document.body.classList.remove('overlay-open');
  el.removeEventListener('keydown', hsTrap);
  var back = el._hsReturn; el._hsReturn = null;
  if (back && back.focus && document.contains(back)) back.focus({ preventScroll: true });
}
function hsMoney(cents) {
  return (window.Shopify && Shopify.currency ? '' : '') + '$' + (cents / 100).toFixed(2);
}

// Predictive search overlay.
hsSafe('search-overlay', function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var status = overlay.querySelector('[data-search-status]');
  var all = overlay.querySelector('[data-search-all]');
  var starts = overlay.querySelector('[data-search-starts]');
  var timer;
  function showStarts() {
    starts.hidden = false; results.hidden = true; status.hidden = true; all.hidden = true;
  }

  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      hsOpen(overlay);
      setTimeout(function () { input.focus(); }, 60);
    });
  });
  overlay.querySelectorAll('[data-search-close]').forEach(function (b) {
    b.addEventListener('click', function () { hsClose(overlay); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) hsClose(overlay);
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.innerHTML = ''; showStarts(); return; }
    starts.hidden = true; results.hidden = false; status.hidden = false;
    status.textContent = (window.hsT && hsT.searching) || 'Searching…';
    timer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          // Same rule as hidden-product.liquid: the size-exchange form and anything
          // tagged hidden never surface, here or in results. Hydrogen never sees
          // them at all — they are only published to the Online Store channel.
          var rule = window.hsHide || {};
          items = items.filter(function (p) {
            var h = String(p.handle || '');
            var tags = Array.isArray(p.tags) ? p.tags : [];
            var type = String(p.type || '');
            if (h.indexOf('exchange-form') > -1 || h.indexOf('return-form') > -1 || tags.indexOf('hidden') > -1) return false;
            var nm = (h + ' ' + (p.title || '')).toLowerCase();
            if ((rule.names || []).some(function (w) { w = String(w).trim(); return w && nm.indexOf(w) > -1; })) return false;
            if (rule.nfl && (type.indexOf('NFL') > -1 || tags.indexOf('NFL') > -1)) return false;
            if (p.available === false) {
              if (rule.soldNfl && type === 'NFL Onesie') return false;
              if (rule.soldHats && type.indexOf('Hat') > -1) {
                var name = (h + ' ' + (p.title || '')).toLowerCase();
                var keep = (rule.keep || []).some(function (w) { w = String(w).trim(); return w && name.indexOf(w) > -1; });
                if (!keep) return false;
              }
            }
            return true;
          });
          if (!items.length) { results.innerHTML = ''; status.textContent = ((window.hsT && hsT.noResults) || 'No results for “%q”').replace('%q', q); all.hidden = true; return; }
          status.hidden = false;
          status.textContent = items.length + ' ' + (items.length === 1 ? ((window.hsT && hsT.result) || 'result') : ((window.hsT && hsT.results) || 'results'));
          results.innerHTML = items.map(function (p) {
            var src = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            // predictive search returns the original upload; a 400px render loads instantly
            if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
            var img = src ? '<img src="' + src + '" alt="" width="200" height="250" loading="eager" decoding="async">' : '';
            return '<a href="' + p.url + '">' + img + '<div class="t">' + p.title + '</div><div class="p">' + (p.price ? '$' + p.price : '') + '</div></a>';
          }).join('');
          all.href = '/search?q=' + encodeURIComponent(q);
          all.hidden = false;
        })
        .catch(function () { status.textContent = (window.hsT && hsT.unavailable) || 'Search is unavailable right now.'; });
    }, 220);
  });
});

// AJAX cart drawer.
hsSafe('cart-drawer', function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var body = drawer.querySelector('[data-cart-body]');
  var totalEl = drawer.querySelector('[data-cart-total]');
  var shipEl = drawer.querySelector('[data-cart-ship]');

  function render(cart) {
    var count = cart.item_count;
    var badge = document.querySelector('[data-cart-count]');
    if (badge) { badge.textContent = count; badge.hidden = count === 0; }
    totalEl.textContent = hsMoney(cart.total_price);

    var min = (window.hsFreeShip || 80) * 100;
    if (count && cart.total_price < min) {
      var pct = Math.round((cart.total_price / min) * 100);
      shipEl.innerHTML = '<p class="eyebrow" style="color:var(--color-ink-muted);margin-bottom:.5rem">' +
        ((window.hsT && hsT.away) || '%a away from free shipping').replace('%a', hsMoney(min - cart.total_price)) + '</p>' +
        '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div>';
    } else if (count) {
      shipEl.innerHTML = '<p class="eyebrow" style="color:var(--color-lamp)">' + ((window.hsT && hsT.freeUnlocked) || 'Free shipping unlocked') + '</p>';
    } else { shipEl.innerHTML = ''; }

    if (!count) {
      body.innerHTML = '<p class="drawer__empty">' + ((window.hsT && hsT.emptyCart) || 'No puck in the net yet.') + '</p>';
      return;
    }
    var T = window.hsT || {};
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '&width=140" alt="' + hsEsc(i.product_title || i.title || '') + '" width="62" height="78">' : '<div></div>';
      return '<div class="drawer__row" data-key="' + i.key + '">' + img +
        '<div><div class="t">' + i.product_title + '</div><div class="v">' +
        (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '') + '</div>' +
        '<div class="drawer__line">' +
          '<span class="drawer__qty"><button type="button" data-qty="' + (i.quantity - 1) + '" aria-label="' + (T.decrease || 'Decrease quantity') + '"' + (i.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
          '<span class="mono">' + i.quantity + '</span>' +
          '<button type="button" data-qty="' + (i.quantity + 1) + '" aria-label="' + (T.increase || 'Increase quantity') + '">+</button></span>' +
          '<button type="button" class="drawer__remove mono" data-qty="0">' + (T.remove || 'Remove') + '</button>' +
        '</div></div>' +
        '<div class="mono">' + hsMoney(i.final_line_price) + '</div></div>';
    }).join('');
    upsell(cart);
  }

  // Quantity / remove: one delegated handler, /cart/change.js by line key.
  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var row = b.closest('[data-key]');
    if (!row) return;
    b.disabled = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: row.getAttribute('data-key'), quantity: parseInt(b.getAttribute('data-qty'), 10) }) })
      .then(function () { return refresh(false); })
      .catch(function () { b.disabled = false; });
  });

  // "Complete the kit" — Shopify's recommendations for the first line, quick-add.
  var upsellEl = drawer.querySelector('[data-cart-upsell]');
  function upsell(cart) {
    if (!upsellEl) return;
    if (!cart.items.length) { upsellEl.innerHTML = ''; return; }
    var inCart = cart.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=6&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var T = window.hsT || {};
        var picks = (d.products || []).filter(function (p) { return inCart.indexOf(p.id) < 0 && p.available; }).slice(0, 3);
        if (!picks.length) { upsellEl.innerHTML = ''; return; }
        upsellEl.innerHTML = '<p class="eyebrow drawer__upsell-title">' + (T.completeKit || 'Complete the kit') + '</p><div class="drawer__upsell">' +
          picks.map(function (p) {
            var v = p.variants.filter(function (x) { return x.available; })[0];
            // A sized kit (onesie, union suit) must not be added in whatever size
            // came first — send those to the page to pick one.
            if (v && p.variants.length > 1) v = null;
            var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + hsEsc(p.title || '') + '" width="72" height="90" loading="lazy">' : '';
            return '<div class="drawer__pick"><a href="' + p.url + '">' + img + '</a><div><a class="t" href="' + p.url + '">' + p.title + '</a><div class="v mono">' + hsMoney(p.price) + '</div></div>' +
              (v ? '<button type="button" class="mono drawer__pick-add" data-add="' + v.id + '">' + (T.add || 'Add') + '</button>' : '<a class="mono drawer__pick-add drawer__pick-add--link" href="' + p.url + '">' + (T.pickSize || 'Pick size') + '</a>') + '</div>';
          }).join('') + '</div>';
      }).catch(function () { upsellEl.innerHTML = ''; });
  }
  if (upsellEl) upsellEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b) return;
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(b.getAttribute('data-add'), 10), quantity: 1 }) })
      .then(function () { return refresh(false); })
      .catch(function () { b.disabled = false; });
  });

  function refresh(open) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      render(c);
      if (open) hsOpen(drawer);
      return c;
    });
  }

  // Quick add from product cards (one-size products only): add, open the drawer.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true; var was = b.textContent; b.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return refresh(true); })
      .catch(function () { location.href = b.closest('.card-wrap').querySelector('a.card').href; })
      .then(function () { b.disabled = false; b.textContent = was; });
  });

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', function () { hsClose(drawer); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) hsClose(drawer);
  });

  // Intercept the product form so adding opens the drawer instead of reloading.
  var form = document.getElementById('pdp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refresh(true); })
        .catch(function () { form.submit(); });   // fall back to a normal POST
    });
  }
});

// League tabs in the Shop-by-team dropdown — Hydrogen shows one league at a
// time behind an NHL/NFL toggle rather than stacking both grids.
hsSafe('leagueTabs', function () {
  document.querySelectorAll('.team-menu').forEach(function (menu) {
    var tabs = menu.querySelectorAll('.league-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var league = tab.getAttribute('data-league');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        menu.querySelectorAll('[data-league-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-league-panel') !== league;
        });
      });
    });
  });
});

// Size guide drawer — Hydrogen's SizeGuideAside, opened from the PDP button.
hsSafe('size-guide', function () {
  var drawer = document.querySelector('[data-size-guide]');
  if (!drawer) return;
  document.querySelectorAll('[data-size-guide-open]').forEach(function (b) {
    b.addEventListener('click', function () { hsOpen(drawer); });
  });
  drawer.querySelectorAll('[data-size-guide-close]').forEach(function (b) {
    b.addEventListener('click', function () { hsClose(drawer); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) hsClose(drawer);
  });
});

// Email capture — once per visitor, after an 18s dwell or on exit intent.
// Mirrors Hydrogen's EmailCapture, same storage key so a visitor who has
// dismissed it on one build never sees it on the other.
hsSafe('email-capture', function () {
  var el = document.querySelector('[data-email-capture]');
  if (!el) return;
  var KEY = 'hs_email_capture_v1';
  var seen = false;
  try { seen = !!window.localStorage.getItem(KEY); } catch (e) { seen = false; }
  function persist() { try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  function close() { persist(); el.hidden = true; }
  el.querySelectorAll('[data-capture-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });

  // A successful post reloads with the thank-you state: show it and persist.
  // posted_successfully? is true for every customer form on the page after
  // any one of them posts, so only claim it when the hash names our form.
  if (el.hasAttribute('data-done')) {
    if (/#(hs-capture-form|capture-inline-form)$/.test(location.hash)) { el.hidden = false; persist(); }
    return;
  }
  if (seen) return;

  var shown = false;
  function show() { if (shown) return; shown = true; el.hidden = false; }
  var timer = window.setTimeout(show, 18000);
  document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) show(); });
  el.addEventListener('submit', function () { persist(); window.clearTimeout(timer); });
});

// Policy pages: Shopify renders fixed .shopify-policy__* markup and ignores
// the theme template, so Hydrogen's "Fine print" eyebrow, rink mark and
// "All policies" link are added here instead.
hsSafe('policy-chrome', function () {
  var title = document.querySelector('.shopify-policy__title');
  var body = document.querySelector('.shopify-policy__body');
  if (!title || !body) return;
  var rink = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  rink.setAttribute('class', 'page-hero__rink');
  rink.setAttribute('viewBox', '0 0 200 200');
  rink.setAttribute('aria-hidden', 'true');
  rink.innerHTML = '<circle cx="100" cy="100" r="98" fill="none" stroke="white" stroke-width="0.6"></circle><circle cx="100" cy="100" r="20" fill="none" stroke="var(--color-lamp)" stroke-width="1"></circle>';
  title.insertBefore(rink, title.firstChild);
  var eyebrow = document.createElement('span');
  eyebrow.className = 'eyebrow';
  eyebrow.textContent = (window.hsT && hsT.finePrint) || 'Fine print';
  title.insertBefore(eyebrow, title.querySelector('h1'));
  // Shopify has no /policies index (it 404s), so link the other policies instead.
  var back = document.createElement('p');
  back.className = 'policy-back mono';
  var here = location.pathname.replace(/\/$/, '');
  back.innerHTML = [['/policies/refund-policy', 'Refund policy'], ['/policies/privacy-policy', 'Privacy policy'], ['/policies/terms-of-service', 'Terms of service'], ['/pages/shipping', 'Shipping']]
    .filter(function (p) { return p[0] !== here; })
    .map(function (p) { return '<a href="' + p[0] + '">' + p[1] + '</a>'; }).join(' &middot; ');
  body.insertBefore(back, body.firstChild);
});

// Size buttons follow the product's option order, which came out of the
// import reversed (XL first). Hydrogen orders them small to large.
hsSafe('size-order', function () {
  var rank = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, XXXL: 7 };
  document.querySelectorAll('.pdp__sizes').forEach(function (wrap) {
    var btns = [].slice.call(wrap.querySelectorAll('.pdp__size'));
    if (btns.length < 2) return;
    btns.sort(function (a, b) {
      var ra = rank[a.textContent.trim().toUpperCase()], rb = rank[b.textContent.trim().toUpperCase()];
      if (ra == null || rb == null) return 0;
      return ra - rb;
    }).forEach(function (b) { wrap.appendChild(b); });
  });
});


// Mobile sheet — burger toggles it, accordions per section; the league tabs
// inside reuse the same handler as the desktop dropdown (.team-menu).
hsSafe('mobile-menu', function () {
  var menu = document.querySelector('[data-mobile-menu]');
  var btn = document.querySelector('[data-menu-toggle]');
  if (!menu || !btn) return;
  function set(open) {
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
    if (open) { menu.addEventListener('keydown', hsTrap); var f = menu.querySelector(hsFocusable); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30); }
    else { menu.removeEventListener('keydown', hsTrap); btn.focus({ preventScroll: true }); }
  }
  btn.addEventListener('click', function () { set(menu.hidden); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) set(false); });
  menu.querySelectorAll('[data-acc]').forEach(function (row) {
    row.addEventListener('click', function () {
      var open = row.getAttribute('aria-expanded') !== 'true';
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
      row.nextElementSibling.hidden = !open;
    });
  });
  window.addEventListener('resize', function () { if (innerWidth >= 1024 && !menu.hidden) set(false); });
});

// NHL score ticker. Data comes from the Hydrogen app's /api/scores (the NHL's
// own API sends no CORS headers). The section starts hidden and only reveals
// itself once a payload with games arrives, so a failure leaves no empty band.
hsSafe('scores', function () {
  var root = document.querySelector('[data-scores]');
  if (!root || !window.fetch) return;
  var track = root.querySelector('[data-scores-track]');
  var labelEl = root.querySelector('[data-scores-label]');
  var dot = root.querySelector('[data-scores-dot]');
  var url = root.getAttribute('data-url');
  var limit = parseInt(root.getAttribute('data-limit'), 10) || 14;
  var pollMs = (parseInt(root.getAttribute('data-poll'), 10) || 45) * 1000;
  var crestBase = root.getAttribute('data-crest-base') || '';
  if (!url) return;

  var LABELS = {
    live: root.getAttribute('data-label-live') || 'Live Scores',
    today: root.getAttribute('data-label-today') || "Today's Scores",
    upcoming: root.getAttribute('data-label-upcoming') || 'Up Next'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function side(team, dim) {
    var abbrev = esc(team && team.abbrev);
    if (!abbrev) return '';
    var crest = crestBase
      ? '<img class="scores__crest" src="' + crestBase + abbrev + '_dark.svg" alt="" aria-hidden="true"' +
        ' width="22" height="22" loading="lazy" onerror="this.style.display=\'none\'">'
      : '';
    var score = (team && team.score !== null && team.score !== undefined)
      ? '<span class="mono scores__score">' + esc(team.score) + '</span>' : '';
    return '<span class="scores__side' + (dim ? ' is-dim' : '') + '">' + crest +
           '<span class="mono scores__abbrev">' + abbrev + '</span>' + score + '</span>';
  }

  function chip(g) {
    var a = g.away || {}, h = g.home || {};
    // On a finished game dim the loser, so "who won" reads at a glance.
    var done = g.state === 'final' && a.score != null && h.score != null;
    return '<span class="scores__game">' +
      side(a, done && a.score < h.score) +
      '<span class="mono scores__vs" aria-hidden="true">' + (g.state === 'upcoming' ? '@' : '—') + '</span>' +
      side(h, done && h.score < a.score) +
      '<span class="mono scores__status' + (g.state === 'live' ? ' is-live' : '') + '">' + esc(g.status) + '</span>' +
      '</span>';
  }

  function render(data) {
    var games = (data && data.games) || [];
    if (!games.length) return;                 // keep whatever was last shown
    var html = games.slice(0, limit).map(chip).join('');
    // Duplicated once so the marquee can loop without a visible seam.
    track.innerHTML = '<div class="scores__lane">' + html + html + '</div>';
    labelEl.textContent = LABELS[data.mode] || LABELS.upcoming;
    dot.hidden = data.mode !== 'live';
    root.hidden = false;
  }

  function load() {
    fetch(url, { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) render(d); })
      .catch(function () { /* leave the last good payload in place */ });
  }

  load();
  setInterval(load, pollMs);
});

/* ---------------------------------------------------------------------------
   Product image zoom.

   Two behaviours off one pair of sources. With a mouse, hovering the main
   image pans a 2400px copy under the cursor, which is what shoppers expect
   from a fabric-and-stitching product. On touch, where hover does not exist,
   tapping opens that same copy full-screen so it can be pinched. Thumbnails
   swap the display and zoom sources together so the two never drift apart.
--------------------------------------------------------------------------- */
hsSafe('image-zoom', function () {
  var stage = document.querySelector('[data-zoom-stage]');
  if (!stage) return;

  var main = stage.querySelector('#pdp-main');
  var lens = stage.querySelector('[data-zoom-lens]');
  if (!main || !lens) return;

  var SCALE = 2.4;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Keep the thumbnails and the zoom source in step.
  var thumbs = document.querySelectorAll('.pdp__thumbs img');
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function () {
      var full = t.getAttribute('data-full');
      var zoom = t.getAttribute('data-zoom');
      if (full) main.src = full;
      if (zoom) main.setAttribute('data-zoom', zoom);
      lens.style.backgroundImage = '';        // reloaded lazily on next hover
      Array.prototype.forEach.call(thumbs, function (o) { o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  if (canHover) {
    stage.classList.add('can-zoom');

    stage.addEventListener('mouseenter', function () {
      var src = main.getAttribute('data-zoom');
      if (src && lens.style.backgroundImage.indexOf(src) === -1) {
        lens.style.backgroundImage = 'url("' + src + '")';
      }
      // The lens shares the image's padding, so the zoom source is sized off
      // the image's content box. Anything else makes the zoomed view jump
      // relative to the one it replaces.
      var cs = getComputedStyle(main);
      var w = main.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var h = main.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      lens.style.backgroundSize = (w * SCALE) + 'px ' + (h * SCALE) + 'px';
      stage.classList.add('is-zooming');
    });

    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zooming');
    });

    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      // Clamp so the edges of the image can be reached but not overshot.
      var x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
      var y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1);
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
    });

    return;
  }

  // Touch: a full-screen viewer the browser can pinch natively.
  stage.classList.add('can-tap-zoom');

  var viewer = null;
  function open() {
    if (viewer) return;
    viewer = document.createElement('div');
    viewer.className = 'zoom-viewer';
    viewer.innerHTML =
      '<button type="button" class="zoom-viewer__close" aria-label="Close">&times;</button>' +
      '<img src="' + (main.getAttribute('data-zoom') || main.src) + '" alt="' + (main.alt || '') + '">';
    viewer.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG') close();
    });
    document.body.appendChild(viewer);
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!viewer) return;
    viewer.remove();
    viewer = null;
    document.body.style.overflow = '';
  }

  stage.addEventListener('click', open);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
});

/* ---------------------------------------------------------------------------
   Market lock — cart stamp.

   Shopify places each visitor in the Canadian or US market by IP, but will
   re-price a checkout into the other market's currency the moment the
   shipping country crosses the border. The merchant does not want that,
   ever. Two Shopify Functions in apps/devlift-setup refuse a cross-border
   address — and they need to know which market the visitor *arrived* in,
   because by the time they run, Shopify has already moved the cart.

   So the cart carries a `_market` attribute, written once. It is never
   overwritten: the first market wins, which is exactly the lock.
--------------------------------------------------------------------------- */
hsSafe('market-lock', function () {
  var market = window.hsMarket;
  if (market !== 'CA' && market !== 'US') return;

  var stamping = false;
  function stamp() {
    if (stamping) return;
    stamping = true;
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        if (cart.attributes && cart.attributes._market) return;   // already locked
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _market: market } })
        });
      })
      .catch(function () { /* next add or page load will retry */ })
      .then(function () { stamping = false; });
  }

  // Any successful add — product form, drawer upsell, anything else that
  // hits the Cart API — is followed by a stamp check.
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok) stamp(); }, function () {});
    }
    return p;
  };

  // A cart from before this shipped, or one filled by the non-JS fallback
  // form post, gets stamped on the next page view.
  stamp();
});

// After a customer form posts, Shopify reloads the page with ?customer_posted=true
// and #<form id>. Every customer form on the page then renders its success
// state; keep only the one that actually posted.
hsSafe('posted-for', function () {
  if (location.search.indexOf('customer_posted=true') < 0) return;
  var id = location.hash.replace('#', '');
  document.querySelectorAll('[data-posted-for]').forEach(function (el) { if (el.getAttribute('data-posted-for') !== id) el.hidden = true; });
  document.querySelectorAll('[data-posted-fields]').forEach(function (el) { if (el.getAttribute('data-posted-fields') !== id) el.hidden = false; });
});

/* Home hero scroll cue: smooth-scroll to the next section, fade once scrolled. */
hsSafe('hero-scroll', function () {
  var cue = document.querySelector('[data-hero-scroll]');
  if (!cue) return;
  var hero = cue.closest('[data-hero]');
  cue.addEventListener('click', function (e) {
    e.preventDefault();
    var next = hero && hero.nextElementSibling;
    while (next && (next.offsetHeight === 0 || next.id === 'hero-next')) next = next.nextElementSibling;
    var header = document.querySelector('.site-header');
    var y = (next || hero).getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0) + (next ? 0 : hero.offsetHeight);
    window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  var onScroll = function () { cue.classList.toggle('is-gone', window.scrollY > 80); };
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
});
